import React, { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Scorrimento orizzontale con scroll-snap: riduce l'ingombro verticale delle gallery mantenendo tutti i contenuti.
export function Carousel({ children, itemClass = "w-[78vw] sm:w-[46vw] lg:w-[31%]", testId, className }) {
  const ref = useRef(null);
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);

  const update = () => {
    const el = ref.current;
    if (!el) return;
    setCanPrev(el.scrollLeft > 4);
    setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 4);
  };
  useEffect(() => {
    update();
    const el = ref.current;
    if (!el) return undefined;
    el.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      el.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, [children]);

  const go = (dir) => {
    const el = ref.current;
    if (el) el.scrollBy({ left: dir * el.clientWidth * 0.85, behavior: "smooth" });
  };
  const items = React.Children.toArray(children);
  const btn = "h-10 w-10 border border-copper/40 flex items-center justify-center text-copper hover:bg-copper hover:text-obsidian transition-colors disabled:opacity-25 disabled:hover:bg-transparent disabled:hover:text-copper";

  return (
    <div className={"relative " + (className || "")} data-testid={testId}>
      <div ref={ref} className="flex gap-4 sm:gap-5 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-2 no-scrollbar" style={{ scrollbarWidth: "none" }}>
        {items.map((child, i) => (
          <div key={i} className={"shrink-0 snap-start " + itemClass} data-testid={testId ? `${testId}-item-${i}` : undefined}>
            {child}
          </div>
        ))}
      </div>
      {items.length > 1 && (canPrev || canNext) && (
        <div className="flex items-center justify-between mt-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-sand">{items.length} {items.length === 1 ? "elemento" : "elementi"}</span>
          <div className="flex gap-2">
            <button type="button" onClick={() => go(-1)} disabled={!canPrev} className={btn} aria-label="Precedente" data-testid={testId ? `${testId}-prev` : undefined}><ChevronLeft className="h-4 w-4" /></button>
            <button type="button" onClick={() => go(1)} disabled={!canNext} className={btn} aria-label="Successivo" data-testid={testId ? `${testId}-next` : undefined}><ChevronRight className="h-4 w-4" /></button>
          </div>
        </div>
      )}
    </div>
  );
}
